var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("defaultValue"),_vm._v(" "+_vm._s(_vm.hasSlotContent ? _vm.displayValue : '')+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }